import { render, staticRenderFns } from "./MessageDisplay.vue?vue&type=template&id=4f54b144&scoped=true&"
import script from "./MessageDisplay.vue?vue&type=script&lang=js&"
export * from "./MessageDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MessageDisplay.vue?vue&type=style&index=0&id=4f54b144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f54b144",
  null
  
)

export default component.exports